const frameSizeToLetter: any = {
    'Medium': 'M',
    'Large': 'L',
    'Extra Small': 'XS',
    'Small': 'S'
}

export const isMultifocalPrescription = (prescription: any) => {
    if (isPrescriptionOnlyHasFile(prescription)) {
        return true;
    }

    if (prescription.add_near && prescription.add_near !== '0' && prescription.add_near !== null) {
        return true;
    }

    if (prescription.left_near_add !== '0' && prescription.left_near_add !== null || prescription.right_near_add !== '0' && prescription.right_near_add !== null) {
        return true;
    }

    return false
}

export const isPrescriptionOnlyHasFile = (prescription: any) => {
    if (prescription.standardised_prescription_display_array.left === 'L Plano DS' &&
        prescription.standardised_prescription_display_array.right === 'R Plano DS' &&
        prescription.files && prescription.files.length > 0) {
        return true;
    }
    return false
}

export const properSize = (size: any) => {
    if (size in frameSizeToLetter) {
        return frameSizeToLetter[size];
    }
    return size;
}